var render, staticRenderFns
import script from "./sales_volume.vue?vue&type=script&lang=js&"
export * from "./sales_volume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdc3beb')) {
      api.createRecord('0bdc3beb', component.options)
    } else {
      api.reload('0bdc3beb', component.options)
    }
    
  }
}
component.options.__file = "found/views/dms/views/contract/components/sales_volume.vue"
export default component.exports